import React, { useState } from "react";
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    TextField,
    Button,
    Select,
    MenuItem,
} from "@mui/material";
import { Mail, Person, CalendarToday } from "@mui/icons-material";
import "./OnboardingScreen.css";
import API_ENDPOINTS from "../../apis/endpoints";
import { useNavigate } from "react-router-dom";
import useAuth from "../../context";

function OnboardingScreen() {
    const navigate = useNavigate();
    const auth = useAuth();

    const [formData, setFormData] = useState({
        email: "",
        userType: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAddUser = async (e) => {
        e.preventDefault();

        const storedDeviceId = localStorage.getItem("device-id");

        let sendData = new FormData();
        sendData.append("email", formData.email);
        sendData.append("role", formData.userType);

        try {
            await fetch(`${API_ENDPOINTS.ADMIN_USER}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth.accessToken}`,
                    "x-cc-device-id": storedDeviceId,
                },
                body: sendData,
            });
            navigate("/dashboard/view-user");
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="profile-container">
            <Card className="profile-card">
                <CardHeader title={<h1 className="card-title">Add User</h1>} />
                <CardContent>
                    <form onSubmit={handleAddUser} className="onboarding-form">
                        <div className="info-card">
                            <Mail className="icon-primary" />
                            <div className="input-container">
                                <p className="input-label">Email Address</p>
                                <TextField
                                    fullWidth
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    variant="outlined"
                                    className="styled-input"
                                />
                            </div>
                        </div>

                        <div className="info-card">
                            <Person className="icon-primary" />
                            <div className="input-container">
                                <p className="input-label">User Type</p>
                                <Select
                                    fullWidth
                                    name="userType"
                                    value={formData.userType}
                                    onChange={handleInputChange}
                                    required
                                    variant="outlined"
                                    className="styled-input"
                                >
                                    <MenuItem value="">Select Type</MenuItem>
                                    <MenuItem value="admin">Admin</MenuItem>
                                    <MenuItem value="agent">Agent</MenuItem>
                                    <MenuItem value="talent">Talent</MenuItem>
                                </Select>
                            </div>
                        </div>

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            className="submit-button"
                        >
                            Submit
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}

export default OnboardingScreen;
